import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { apiService } from "../../../utils/api";
import "./WriteDocument.css"; // Add this import
import { initSecurityMeasures } from "../../../utils/security";
import { FaCheck, FaClock, FaFileAlt } from "react-icons/fa";

function SelectImageDoc() {
  const [teacherDocuments, setTeacherDocuments] = useState([]);
  const [todayAttempted, setTodayAttempted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchTeacherDocuments = async () => {
      try {
        const response = await apiService.getImageDocumentByStudentBatch();
        const data = response.data;

        if (data.success) {
          setTeacherDocuments(data.documents);
          setTodayAttempted(data.todayAttempted);
        } else {
          setError(data.message);
        }
      } catch (err) {
        setError(err.response?.data?.message || "Error fetching teacher documents");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchTeacherDocuments();
  }, []);

  if (loading) {
    return <p>Loading documents...</p>;
  }

  const handleSelectDocument = (documentId, givenTo , id) => {
    if (!givenTo) {
      if (todayAttempted) {
        alert("You have already attempted today's document");
        return;
      }
      navigate(`/write-image/${documentId}`);
    } else {
      navigate(`/comparison-image-results/${id}`);
    }
  };

  return (
    <div className="write-document-container">
      <h2>Select Document</h2>

      {error && <p className="error-message">{error}</p>}

      <div className="documents-grid">
        {teacherDocuments.map((doc) => (
          <div key={doc.id} className="document-card" onClick={() => handleSelectDocument(doc.id, doc.givenTo, doc.studentDocId)} style={{ cursor: doc.givenTo ? "not-allowed" : "pointer" }}>
            <div className="document-icon">
              <FaFileAlt />
            </div>
            <div className="document-info">
              <h4>{doc.title}</h4>
              <p className="document-date"> Created: {new Date(doc.createdAt).toLocaleDateString()} </p>
              <p style={{ color: doc.givenTo ? "green" : "red" }}>Status: {doc.givenTo ? "Attempted" : "Not Attempted "}</p>
            </div>
            <div className="document-actions">
              <p style={{ color: doc.givenTo ? "green" : "red" }}>{doc.givenTo ? <FaCheck /> : <FaClock />}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SelectImageDoc;
